// Past employer taxes
export const PAST_EMPLOYER_TAXES_STATUS_IN_DRAFT = 'Draft';
export const PAST_EMPLOYER_TAXES_STATUS_IN_APPROVED = 'Approved';
export const PAST_EMPLOYER_TAXES_STATUS_IN_REVIEW = 'Under Review';
export const PAST_EMPLOYER_TAXES_STATUS_IN_REJECT = 'Rejected';
export const REPORT_STATUS_REJECTED = 'REJECTED';
export const LOCK_STATUS_UNLOCKED = 'UNLOCKED';
export const ENTITY_ORIGIN_SYSTEM_DEFINED = 'ENTITY_SYSTEM_DEFINED';
